import {
    OreButton,
    OreDivider,
    OreHeading,
    OreStack,
    OreText,
    SvgPlus,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/Shared/ui/layout'
import { accessRolesTranslation } from '../AccesRolesTranslation'
import { AccessRolesList } from '../organisms'
import { OreModalCreateProfile } from '@/partnersGroups/ui/organisms/OreModalCreateProfile'
import { useEffect, useState } from 'react'
import { useUserData } from '@/User/ui/context'
import { GroupType } from '@/partnersGroups/domain/ProfileTypes'
import { useWebTagPermissions } from '@/User/context'
import { WebTagPermissionEnum } from '@/Shared/domain'
import { navigationRoutes } from '@/Shared/ui/routers'

export const AccessRolesPage = (): JSX.Element => {
    const { t } = useTranslation()
    const { hasPermission } = useWebTagPermissions();
    const { merchant } = useUserData()
    const [open, setOpen] = useState(false);
    const groupType: GroupType = {
        isChildCommercial: merchant.isChildCommercial,
        isChildWithHardDependency: merchant.isChildWithHardDependency,
        isParent: merchant.isParent,
        isIndependent: merchant.isIndependent,
        isMasterGroup: merchant.isMasterGroup
    };
    const [refresh, setRefresh] = useState(0);
    const handleOnClose = () => {
        setOpen(false);
        setRefresh(r => r + 1); // Incrementa para forzar la reinstanciación
    };
    useEffect(() => {
        if(!hasPermission(WebTagPermissionEnum.VIEW_SHOW_WEB_ACCOUNTS_HANDLING)) {
            window.location.href = navigationRoutes.home;
        }
    }, []);
    return (
        <PageWrapper
        paddingSmaller
        paddingTop={8}
        style={{
            paddingRight: 40,
            paddingLeft: 40,
            minWidth: '-webkit-fill-available',
            marginRight: 0,
            marginLeft: 0,
        }}>
            <OreStack direction="row" placeContent="space-between" placeItems="center">
                <OreHeading as="h1" size="title-sm">
                    {t(accessRolesTranslation.title)}
                </OreHeading>
                <OreButton
                    category="primary"
                    icon={<SvgPlus />}
                    onClick={() => setOpen(true)}
                >
                    {t(accessRolesTranslation.createButton)}
                </OreButton>
            </OreStack>
            <OreDivider space="larger-bottom" />
            <OreText tone='neutral-800' >
                {t(accessRolesTranslation.description)}
            </OreText>
            <OreStack space="xlarge" placeContent="stretch" style={{ marginTop: '2rem' }}>
                <AccessRolesList
                    key={refresh}
                    setRefresh={setRefresh}
                    groupType={groupType}
                />
            </OreStack>
            <OreModalCreateProfile
                open={open}
                onClose={handleOnClose}
                groupType={groupType}
            />
        </PageWrapper>
    )
}
